import {
  FullLogotypeGroup,
  FullLogotypePetrotec,
  FullLogotypePetroassist,
  ShortLogotype,
} from "./Icons";
import Link from "next/link";
import { prefix } from "../../utils/utils";
export default function LogoAnimation({
  scrollPosition,
  scrollTrigger,
  websiteType,
  setOpenModal,
  setOpenModalSmall,
}) {
  return (
    <>
      <Link
        href={prefix("/")}
        as={prefix("/")}
        onClick={() => {
          setOpenModal(null);
          setOpenModalSmall(false);
        }}
        aria-label="homepage"
        aria-hidden={scrollPosition > scrollTrigger}
        tabIndex={scrollPosition > scrollTrigger ? -1 : 0}
      >
        {websiteType === "petrotec-group" ? (
          <FullLogotypeGroup
            extraClass={`petrotec-group-logo duration-500 ${
              scrollPosition < scrollTrigger ? "" : "full-logo-animation"
            }`}
          />
        ) : websiteType === "petroassist" ? (
          <FullLogotypePetroassist
            extraClass={`petroassist-logo fill-theme-color duration-500 ${
              scrollPosition < scrollTrigger ? "" : "full-logo-animation"
            }`}
          />
        ) : (
          <FullLogotypePetrotec
            extraClass={`petrotec-logo fill-theme-color duration-500 ${
              scrollPosition < scrollTrigger ? "" : "full-logo-animation"
            }`}
          />
        )}
      </Link>
      <Link
        href={prefix("/")}
        as={prefix("/")}
        onClick={() => {
          setOpenModal(null);
          setOpenModalSmall(false);
        }}
        className="absolute left-0"
        aria-label="homepage"
        aria-hidden={scrollPosition < scrollTrigger}
        tabIndex={scrollPosition < scrollTrigger ? -1 : 0}
      >
        <ShortLogotype
          isGroupWebsite={websiteType === "petrotec-group"}
          extraClass={`short-logo fill-theme-color ${
            scrollPosition < scrollTrigger ? "" : "short-logo-animation"
          }`}
        />
      </Link>
    </>
  );
}
